import React, { useCallback, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./style/home.scss";
import { useNavigate } from "react-router-dom";
import { QRScannerCard } from "../../components/common/QRScannerCard/QRScannerCard";
import { showError } from "../../services/toastservice/toastService";
import footerLogo from "../../assets/images/footer-logo.png";
import { useNewVisitorSession } from "../../hooks/useNewVisitorSession";
import { useStrings } from "../../hooks/useStrings";
const Home: React.FC = () => {
  const S = useStrings();
  const { startNewVisitorSession } = useNewVisitorSession();
  const navigate = useNavigate();

  useEffect(() => {
    startNewVisitorSession();
    const error = sessionStorage.getItem("error401");

    if (error === "401") {
      showError("Invalid or Expired QR Code. Please try again!");
      sessionStorage.removeItem("error401");
    } else if (error === "404") {
      showError("Invalid or Expired Pre-Registration link. Please try again!");
      sessionStorage.removeItem("error401");
    } else {
      sessionStorage.removeItem("error401");
    }
  }, []);

  const handleCodeResult = useCallback(
    (decodedText: string) => {
      // QR holds a full URL; navigate() only takes in-app paths (EN-5047)
      const { pathname, search } = new URL(decodedText);
      navigate(pathname + search);
    },
    [navigate],
  );

  const handleScannerError = useCallback((message: string) => {
    showError(message);
  }, []);

  return (
    <div
      className="screen-contactless"
      id="home-page"
      data-testid="home-screen-contactless"
    >
      <Container data-testid="home-container">
        <Row>
          <Col xl={12} lg={12} md={12} sm={12} data-testid="home-col">
            <div className="screen-header-logo">
              <img src={footerLogo} alt="Visitly" />
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center" data-testid="home-row">
          <Col xl={5} lg={6} md={8} sm={10} data-testid="home-col">
            <Card className="card-contactless" data-testid="home-signin-card">
              <Card.Body data-testid="home-signin-card-body">
                <h2 data-testid="home-signin-title">{S.HOME.TITLE}</h2>
                <h6 data-testid="home-signin-subtitle">
                  {S.HOME.SUBTITLE}
                </h6>

                <QRScannerCard
                  onCodeResult={handleCodeResult}
                  onError={handleScannerError}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;
